<script setup lang="ts">
import type { GameVehicleSummary } from "~~/types/gamedata";

defineProps({
  vehicle: {
    type: Object as () => GameVehicleSummary,
    required: true,
  },
});
</script>

<template>
  <div class="flex justify-between">
    <div>
      <h1 class="text-3xl font-bold">{{ vehicle.fullName }}</h1>
    </div>
    <div class="flex flex-wrap">
      <UBadge v-if="vehicle.productionStatus" variant="outline" size="sm" class="ml-auto" :label="vehicle.productionStatus" />
      <span v-if="vehicle.foci[0]" class="text-neutral-400 mt-auto block w-full text-right">Fokus: <span class="font-bold">{{ vehicle.foci.join(' / ') }}</span></span>
    </div>
  </div>
</template>
